import delegate from "delegate-it";
import { scrollTo } from "@/scripts/common/scroll-to";

document.addEventListener("DOMContentLoaded", () => {
  delegate("html", "accordion:open", (e) => {
    const tab = e.detail.tab;

    if (tab) {
      setTimeout(() => {
        scrollTo(tab, 16);
      }, 500);
    }
  });
});
